"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PhaseType;
(function (PhaseType) {
    PhaseType["LOBBY"] = "LOBBY";
    PhaseType["DRAW"] = "DRAW";
    PhaseType["GUESS"] = "GUESS";
    PhaseType["REVEAL"] = "REVEAL";
    PhaseType["END"] = "END";
})(PhaseType = exports.PhaseType || (exports.PhaseType = {}));
var LinkType;
(function (LinkType) {
    LinkType["NONE"] = "none";
    LinkType["IMAGE"] = "image";
    LinkType["PROMPT"] = "prompt";
})(LinkType = exports.LinkType || (exports.LinkType = {}));
var RoomError;
(function (RoomError) {
    RoomError["ROOM_NOT_FOUND"] = "No room with a matching code was found";
    RoomError["ROOM_INITIALISATION_ERROR"] = "Unable to initialise the room";
    RoomError["NETWORK_ERROR"] = "Network error. Please check your connection and try again";
    RoomError["RECONNECT_ERROR"] = "Failed to reconnect";
    RoomError["UNKNOWN_ERROR"] = "An unknown error occured";
})(RoomError = exports.RoomError || (exports.RoomError = {}));
var ServerError;
(function (ServerError) {
    ServerError["TOO_MANY_PLAYERS"] = "The room is already full";
    ServerError["CONFLICTING_USERNAMES"] = "That username has already been taken for this room";
    ServerError["NOT_ENOUGH_PLAYERS"] = "You need at least three players to join this room";
    ServerError["CURATOR_DISCONNECTED"] = "The curator has disconnected. To rejoin as curator, please join the room on curator device, then click \"Reconnect as curator\"";
})(ServerError = exports.ServerError || (exports.ServerError = {}));
var StickyNoteColour;
(function (StickyNoteColour) {
    // disconnected
    StickyNoteColour["GRAY"] = "#bcbcbc";
    StickyNoteColour["RED"] = "#ffb1b1";
    StickyNoteColour["ORANGE"] = "#ffc693";
    StickyNoteColour["YELLOW"] = "#ffeb61";
    StickyNoteColour["GREEN"] = "#adff91";
    StickyNoteColour["CYAN"] = "#9affec";
    StickyNoteColour["BLUE"] = "#9ab5ff";
    StickyNoteColour["PURPLE"] = "#b79aff";
    StickyNoteColour["PINK"] = "#ffc8fb";
})(StickyNoteColour = exports.StickyNoteColour || (exports.StickyNoteColour = {}));
var VoteType;
(function (VoteType) {
    VoteType[VoteType["NONE"] = 0] = "NONE";
    VoteType[VoteType["LIKE"] = 1] = "LIKE";
    VoteType[VoteType["DISLIKE"] = 2] = "DISLIKE";
})(VoteType = exports.VoteType || (exports.VoteType = {}));
var PromptCategory;
(function (PromptCategory) {
    PromptCategory["LEAGUE"] = "League of Legends";
    PromptCategory["CSGO"] = "CS:GO";
    PromptCategory["GENERIC"] = "Items";
    PromptCategory["ACTORS"] = "Actors";
    PromptCategory["FASTFOOD"] = "Fast Food";
    PromptCategory["POKEMON"] = "Pokemon";
    PromptCategory["FLORIDA"] = "Florida man";
})(PromptCategory = exports.PromptCategory || (exports.PromptCategory = {}));
exports.PromptCategories = [
    PromptCategory.GENERIC,
    PromptCategory.FASTFOOD,
    PromptCategory.LEAGUE,
    PromptCategory.ACTORS,
    PromptCategory.CSGO,
    PromptCategory.POKEMON,
];
var GameType;
(function (GameType) {
    GameType["PROMPT_PACK"] = "Prompt Pack";
    GameType["CUSTOM"] = "Custom Prompts";
})(GameType = exports.GameType || (exports.GameType = {}));
